import type { OcrWord } from './ocrTypes';

/**
 * Join words into text for the clipboard. The words sit in absolutely-positioned spans, which a
 * browser copies as one line each; this restores reading order: a space between words on the same
 * line, a newline when the next word starts on a new one. Words arrive in the engine's reading
 * order, so only the line break needs deciding: the next word has moved down by more than half a
 * word-height (heights and y are both measured in image-width units here).
 */
export function joinWordsForCopy(words: readonly OcrWord[], aspect: number): string {
  let out = '';
  words.forEach((w, i) => {
    if (i > 0) {
      const prev = words[i - 1];
      // y is a fraction of image HEIGHT; h is in image-WIDTH units. Bring y to width units: y*aspect.
      const dy = Math.abs(w.y - prev.y) * aspect;
      const newLine = dy > Math.min(prev.h, w.h) * 0.6;
      out += newLine ? '\n' : ' ';
    }
    out += w.text;
  });
  return out;
}
